var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.variant === "desktop"
        ? _c(
            "div",
            { staticClass: "d-flex align-start justify-space-between mb-2" },
            [
              _c("h2", { staticClass: "text-h6 mb-0" }, [
                _vm._v("\n      Врач чаще всего лечит\n    "),
              ]),
              _vm._v(" "),
              _c(_setup.PracticeLogoBadge),
            ],
            1
          )
        : [
            _c(_setup.PracticeLogoBadge, { staticClass: "mb-1" }),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass: "mb-0",
                class: _vm.variant === "drawer" ? "text-h6" : "text-subtitle-1",
              },
              [_vm._v("\n      Врач чаще всего лечит\n    ")]
            ),
          ],
      _vm._v(" "),
      _vm.showDescription
        ? _c(
            "p",
            {
              staticClass: "mb-0",
              class:
                _vm.variant === "drawer"
                  ? "text-body-2 mt-1"
                  : "text-body-1 mt-2",
            },
            [
              _vm._v(
                "\n    Данные реальной практики, полученные из информационных систем клиник на основе реальной практики врача\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }